import { render, staticRenderFns } from "./SimpleItem.vue?vue&type=template&id=42d83f41&scoped=true&"
import script from "./SimpleItem.vue?vue&type=script&lang=js&"
export * from "./SimpleItem.vue?vue&type=script&lang=js&"
import style0 from "./SimpleItem.vue?vue&type=style&index=0&id=42d83f41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d83f41",
  null
  
)

export default component.exports